import React, { Suspense, useEffect, useState } from "react";
import { Routes, Route, Outlet, Navigate } from "react-router-dom";
import FallbackSpinner from "./@core/components/spinner";

import AuthGuard from "src/@core/components/auth/AuthGuard";
import UserLayout from "./layouts/UserLayout";
import BlankLayout from "./@core/layouts/BlankLayout";
import AclGuard from "./@core/components/auth/AclGuard";
import GuestGuard from "./@core/components/auth/GuestGuard";
import { defaultACLObj } from "./configs/acl";
import AuthLayout from "./layouts/AuthLayout";
import BlankLayoutWithAppBar from "./@core/layouts/BlankLayoutWithAppBar";
import ProtectedRoute from "./views/common/ProtectedRoute";
import { useAuth } from "./hooks/useAuth";
import toast from "react-hot-toast";
import { Box, Typography } from "@mui/material";
import { BellOutline } from "mdi-material-ui";
import { onMessage } from "firebase/messaging";
import { getNotificationPermission, messaging } from "./notification/firebase";
import NotificationPage from "./pages/notification";
import RolesPage from "./pages/roles";
import AddEditRolePage from "./pages/roles/AddEditRoles";
import PermissionsPage from "./pages/permissions";
import AddEditPermissionPage from "./pages/permissions/AddEditPermissions";
import SubAdminPage from "./pages/sub-admin";
import LessonPage from "./pages/lesson";
import CoursesPage from "./pages/courses";
import ModulesPage from "./pages/modules";
import CulturalModulePage from "./pages/cultural-module";
import CategoryPage from "./pages/category";
import RegionPage from "./pages/region";
import CulturalModuleDetail from "./pages/cultural-module/CulturalModuleDetail";
import AddEditCulturalModule from "./pages/cultural-module/AddEditCulturalModule";
import PrivacyPolicyPage from "./pages/privacypolicy";
import TermsPage from "./pages/terms";
//admin
const HomePage = React.lazy(() => import("./pages/home"));
const DashboardPage = React.lazy(() => import("./pages/dashboard"));
const LoginPage = React.lazy(() => import("./pages/login"));
const RegisterPage = React.lazy(() => import("./pages/register"));
const ForgotPasswordPage = React.lazy(() => import("./pages/forgot-password"));
const ForgotPassword = React.lazy(() => import("./pages/login/resetpassword"));
const VerifyOtpPage = React.lazy(() => import("./pages/verify-otp"));


const HelpPage = React.lazy(() => import("./pages/help"));
const UserManagementPage = React.lazy(() => import("./pages/user-management"));
const UserDetailPage = React.lazy(() => import("./pages/user-management/UserDetail"));

const Page401 = React.lazy(() => import("./pages/401"));
const Page404 = React.lazy(() => import("./pages/404"));


const Guard = ({ children, authGuard, guestGuard }) => {
  if (guestGuard) {
    return <GuestGuard fallback={<FallbackSpinner />}>{children}</GuestGuard>;
  } else if (!guestGuard && !authGuard) {
    return <>{children}</>;
  } else {
    return <AuthGuard fallback={<FallbackSpinner />}>{children}</AuthGuard>;
  }
};

function App() {
  const aclAbilities = defaultACLObj;
  const { user, getUnReadNotificationCount } = useAuth()
  const { setFcmToken } = useAuth();
  // useEffect(() => {
  //   // Add a small delay to ensure the app is fully loaded
  //   const timer = setTimeout(() => {
  //     console.log('Initializing FCM token...');
  //     getNotificationPermission(setFcmToken);
  //   }, 1000);

  //   return () => clearTimeout(timer);
  // }, [setFcmToken]);

  // useEffect(() => {
  //   // Only set up message listener if messaging is available
  //   if (messaging) {
  //     onMessage(messaging, payload => {
  //       //getUnReadNotificationCount();
  //       toast(
  //         (t) => (
  //           <Box display={"flex"} alignItems={"flex-start"} gap={3}>
  //             {/* <Avatar
  //               src={MessageImage}
  //               alt="NotificationIcon"
  //               variant="square"
  //             /> */}
  //             <BellOutline />
  //             <Box>
  //               <Typography
  //                 sx={{ fontSize: "18px", fontWeight: 600, lineHeight: "25px" }}
  //               >
  //                 {payload.notification.title}
  //               </Typography>
  //               <Typography
  //                 sx={{ fontSize: "14px", fontWeight: 400, lineHeight: "15px" }}
  //               >
  //                 {payload.notification.body}
  //               </Typography>
  //             </Box>
  //           </Box>
  //         ),
  //         {
  //           style: { border: "1px solid #3B8D5C", borderRadius: "12px" },
  //           position: "top-right",
  //           duration: 3000,
  //         }
  //       );
  //       // alert(payload.notification.title);
  //       // alert(payload.notification.body);
  //     });
  //   }
  // }, []);

  return (
    <Suspense fallback={<FallbackSpinner />}>
      <AclGuard aclAbilities={aclAbilities}>
        <Routes>
          <Route
            element={
              <BlankLayout>
                <Outlet />
              </BlankLayout>
            }
          >
            <Route path="/401" element={<Page401 />} />
            <Route path="/404" element={<Page404 />} />

            <Route
              element={
                <AuthLayout>
                  <Outlet />
                </AuthLayout>
              }
            >
              <Route
                element={
                  <Guard guestGuard>
                    <Outlet />
                  </Guard>
                }
              >
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route
                  path="/forgot-password"
                  element={<ForgotPasswordPage />}
                />
                <Route path="/verify-otp" element={<VerifyOtpPage />} />
                <Route path="/reset-password" element={<ForgotPassword />} />
                {/* <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                <Route path="/terms-and-conditions" element={<TermsPage />} /> */}
              </Route>
            </Route>
          </Route>

          <Route
            element={
              // <Guard authGuard>
              <Outlet />
              // </Guard>
            }
          >
            <Route
              element={
                <UserLayout>
                  <Outlet />
                </UserLayout>
              }
            >
              <Route path="" element={<HomePage />} />
              <Route path="/notification" element={<NotificationPage />} />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <DashboardPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/user-management"
                element={
                  <ProtectedRoute>
                    <UserManagementPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/help-support"
                element={
                  <ProtectedRoute>
                    <HelpPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/user-management/:id"
                element={<UserDetailPage />}
              />
              <Route
                path="/roles"
                element={
                  <ProtectedRoute>
                    <RolesPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/roles/add"
                element={
                  <ProtectedRoute>
                    <AddEditRolePage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/roles/edit/:id"
                element={
                  <ProtectedRoute>
                    <AddEditRolePage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/permissions"
                element={
                  <ProtectedRoute>
                    <PermissionsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/permissions/add"
                element={
                  <ProtectedRoute>
                    <AddEditPermissionPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/permissions/edit/:id"
                element={
                  <ProtectedRoute>
                    <AddEditPermissionPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/sub-admin"
                element={
                  <ProtectedRoute>
                    <SubAdminPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/category"
                element={
                  <ProtectedRoute>
                    <CategoryPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/region"
                element={
                  <ProtectedRoute>
                    <RegionPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/courses"
                element={
                  <ProtectedRoute>
                    <CoursesPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/modules/:courseId"
                element={
                  <ProtectedRoute>
                    <ModulesPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/cultural-module"
                element={
                  <ProtectedRoute>
                    <CulturalModulePage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/cultural-module/add"
                element={
                  <ProtectedRoute>
                    <AddEditCulturalModule />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/cultural-module/edit/:id"
                element={
                  <ProtectedRoute>
                    <AddEditCulturalModule />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/cultural-module/:id"
                element={
                  <ProtectedRoute>
                    <CulturalModuleDetail />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/lessons/:moduleId"
                element={
                  <ProtectedRoute>
                    <LessonPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/privacy-policy"
                element={
                  <ProtectedRoute>
                    <PrivacyPolicyPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/terms-and-conditions"
                element={
                  <ProtectedRoute>
                    <TermsPage />
                  </ProtectedRoute>
                }
              />
            </Route>
          </Route>

          {/* If no route found redirect it to --> /404 */}
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>
      </AclGuard>
    </Suspense>
  );
}

export default App;
